"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EUI_THEME_OVERRIDES_KEY = exports.EUI_THEME_HIGH_CONTRAST_MODE_KEY = exports.COLOR_MODES_STANDARD = exports.COLOR_MODES_INVERSE = void 0;
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

var COLOR_MODES_STANDARD = exports.COLOR_MODES_STANDARD = {
  light: 'LIGHT',
  dark: 'DARK'
};
var COLOR_MODES_INVERSE = exports.COLOR_MODES_INVERSE = 'INVERSE';

// Consumers can pass a boolean to manually toggle the preferred high contrast mode,
// but our internal high contrast mode enum is slightly more granular to account for
// Windows's high contrast themes, which force colors/backgrounds/shadows

var EUI_THEME_HIGH_CONTRAST_MODE_KEY = exports.EUI_THEME_HIGH_CONTRAST_MODE_KEY = 'HCM';
var EUI_THEME_OVERRIDES_KEY = exports.EUI_THEME_OVERRIDES_KEY = 'overrides';